/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:25:14
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/tooltip.js
 */
export default {
    // tooltip 组件
    tooltip: {
        text: '',
        copyText: '',
        size: 14,
        color: '#606266',
        bgColor: 'transparent',
        direction: 'top',
        zIndex: 10071,
        showCopy: true,
        buttons: () => [],
        overlay: true,
        showToast: true
    }
}
